/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var util = MoyaContainer.get('core.util');
    MoyaComponents.register('store.parlogis-item', function (el) {
        var item = new ParalogisItem(el);
        item.run();
    });
    var ParalogisItem = /** @class */ (function () {
        function ParalogisItem(el) {
            this.el = el;
        }
        ParalogisItem.prototype.run = function () {
            this.fixOptions();
            this.checkIfInCart();
            this.bind();
            this.updateNoticeText(true);
        };
        ParalogisItem.prototype.bind = function () {
            var _this = this;
            util.delegate(this.el, 'change', 'td.qty select', function (e) {
                var target = e.target;
                var value = target.value;
                var buyboxSelect = _this.el.querySelector('.buyBox .qtyOuter select');
                if (buyboxSelect) {
                    buyboxSelect.value = value;
                    MoyaComponents.run(_this.el.querySelector('.pending-order-notice'));
                    setTimeout(function () {
                        _this.updateNoticeText(true);
                    }, 200);
                }
            });
            util.delegate(this.el, 'click', 'td.cartAdd > button', function (e) {
                var target = e.target;
                target.classList.toggle('inCart');
                var isInCart = target.classList.contains('inCart');
                if (isInCart) {
                    var buyboxCartSubmit = _this.el.querySelector('.buyBox .controls .cartSubmit');
                    if (buyboxCartSubmit) {
                        buyboxCartSubmit.click();
                    }
                }
                else {
                    var item = _this.findItemInCart();
                    var removeButton = item.querySelector('a.cartDelete');
                    if (removeButton) {
                        removeButton.click();
                    }
                }
            });
            util.delegate(this.el, 'click', 'td.info .icon', function () {
                var card = _this.el.querySelector('.card');
                card.classList.toggle('active');
            });
            util.delegate(document.body, 'click', 'body', function (e) {
                var card = _this.el.querySelector('.card');
                if (!_this.el.contains(e.target) && card !== null) {
                    card.classList.remove('active');
                }
            });
        };
        ParalogisItem.prototype.findItemInCart = function () {
            var title = this.el.querySelector('.title').textContent.trim();
            return Array.from(document.querySelectorAll('#storeShoppingBag .storeShoppingBagItem'))
                .find(function (el) {
                return el.textContent.includes(title);
            });
        };
        ParalogisItem.prototype.checkIfInCart = function () {
            var cartAdd = this.el.querySelector('td.cartAdd > button');
            if (cartAdd) {
                var item = this.findItemInCart();
                if (item) {
                    cartAdd.classList.add('inCart');
                    this.updateNoticeText(true);
                }
                else {
                    cartAdd.classList.remove('inCart');
                }
            }
        };
        ParalogisItem.prototype.updateNoticeText = function (shouldAddClass) {
            var qtyStatusElm = this.el.querySelector('td.qty .status');
            if (!qtyStatusElm) {
                return;
            }
            var textElm = this.el.querySelector('.pending-order-notice');
            if (textElm && textElm.textContent.trim() !== '') {
                qtyStatusElm.textContent = textElm.textContent;
                if (shouldAddClass) {
                    this.el.classList.add('notice');
                    qtyStatusElm.classList.add('notice');
                }
            }
            else {
                qtyStatusElm.classList.remove('notice');
                this.el.classList.remove('notice');
            }
        };
        ParalogisItem.prototype.fixOptions = function () {
            var unit = this.el.querySelector('td.qty label');
            if (unit) {
                var unitText_1 = unit.textContent;
                this.el.querySelectorAll('td.qty select option').forEach(function (elm) {
                    elm.label = elm.label + ' ' + unitText_1;
                });
            }
        };
        return ParalogisItem;
    }());
    MoyaEventHandler.on('store.cartDelete', function () {
        // need to wait for stuff to finish
        setTimeout(function () {
            document.querySelectorAll('.paralogis-product').forEach(function (elm) {
                var item = new ParalogisItem(elm);
                item.checkIfInCart();
            });
        }, 400);
    });
    MoyaEventHandler.on('store.cartAdd', function (e) {
        var searchTerm = e.data.itemLabel;
        var xpath = "//*[text()='" + searchTerm + "']";
        var result = document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
        var tableRow = result.parentElement.parentElement.parentElement;
        if (tableRow.classList.contains('outOfStock')) {
            var toastLabel = e.notification.querySelector('.awn-toast-label');
            toastLabel.innerText = 'Vöru bætt í biðpöntun';
            toastLabel.style.color = '#de565d';
        }
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
